<template>
  <div class="ds-control ds-navtab" :class="{ 'ds-no-padding': !showPadding }" :style="{ height: isDesign ? '100%' : tabHeight }">
    <el-tabs v-model="activeName" :tab-position="tabPosition" :type="tabStyle == 'customer-tab-pad' ? '' : tabStyle" :closable="enableDelete" @tab-click="tabClick" @tab-remove="tabRemove">
      <slot></slot>
      <el-tab-pane
        v-for="d in slots.filter(tab => { return isHide(tab) !== true; })"
        :key="d.name"
        :disabled="isdisable(d)"
        :label="d.title"
        :name="d.name"
        :slot-name="d.name"
        :lazy="isLazy(d)"
        :style="{'padding':$padding}"
      >
        <span slot="label">
          <!-- 如果有提示信息但是不显示图标，就在最外层 -->
          <el-popover :placement="placement" :disabled="(!isShowTip(d) || !d.tipContent) ? true : showTipIcon" :trigger="tipTrigger">
            <div v-html="tipContent(d)"></div>
            <span slot="reference">
              <span v-html="dsf.safe.xss(d.title)"></span>
              <!-- 有图标，就在内层，靠图标触发 -->
              <el-popover v-if="showTipIcon && isShowTip(d)" :placement="placement" :disabled="!isShowTip(d) || !d.tipContent" :trigger="tipTrigger">
                <div v-html="tipContent(d)"></div>
                <span slot="reference">
                  <i class="iconfont icon-bangzhuzhongxin tipicon"></i>
                </span>
              </el-popover>
              <span v-if="d.badge !== null" class="el-badge" v-html="dsf.safe.xss(d.badge)"></span>
            </span>
          </el-popover>
        </span>
        <slot :name="d.name"></slot>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default dsf.component({
  name: 'DsfNavTab',
  ctrlCaption: '选项卡',
  mixins: [$mixins.tabControl],
  props: {
    showTipIcon: {
      type: Boolean,
      default: false
    },
    tipTrigger: {
      type: String,
      default: "hover"
    }
  },
  computed: {
    $padding() {
      let padding = this.contentPadding;
      return [
        dsf.isNumber(padding[0]) ? padding[0] + "px" : padding[0],
        dsf.isNumber(padding[1]) ? padding[1] + "px" : padding[1],
        dsf.isNumber(padding[2]) ? padding[2] + "px" : padding[2],
        dsf.isNumber(padding[3]) ? padding[3] + "px" : padding[3]
      ].join(" ")
    },
    placement(){
      let direction = this.tabPosition;
      let placement = "bottom";
      switch(direction){
      case "top":
        placement = "bottom";
        break;
      case "right":
        placement = "left";
        break;
      case "bottom":
        placement = "top";
        break;
      case "left":
        placement = "right";
        break;
      }
      return placement;
    }
  },
  methods: {
    formScrollIntoViewErrorControl(el) {
      const name = $(el).closest('.el-tab-pane').attr('slot-name')
      this.tabChange({ name })
    },
    isShowTip(tab){
      let v = this.$expressParams();
      return this.$eval(tab.showTip, v);
    },
    tipContent(tab){
      if(this.isDesign){
        return tab.tipContent || "";
      }else if (!tab.tipContent) {
        return "";
      } else {
        let v = this.$expressParams();
        return dsf.safe.xss(this.$replace(tab.tipContent, v));
      }
    },
  }
});
</script>
